import format from "date-fns/format";
import isDate from "date-fns/isDate";

export default function(Vue) {
	Vue.filter("timecode",	(value=0) => {
		function zpad(n)
		{
			return n <= 9 ? "0" + n : n;
		}

		value = parseInt(value);

		if (value < 3600)
			return Math.floor(value / 60) + ":" + zpad(value % 60);

		return Math.floor(value / 3600) + ":" +
			zpad(Math.floor(value / 60) % 60) + ":" +
			zpad(value % 60);
	});

	Vue.filter("date", (date=0, dateFormat="yyyy-MM-dd HH:mm:ss xx") => {
		if (Number.isInteger(date))
			date *= 1000;
		else if (!isDate(date))
			return date;

		return format(date, dateFormat);
	});

	Vue.filter("bytes", (bytes, decimals=1) => {
		if (bytes === 0)
			return "0 Bytes";

		if (isNaN(parseFloat(bytes)) && !isFinite(bytes))
			return "Not a number";

		const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
		const k = 1024;
		const i = Math.floor(Math.log(bytes) / Math.log(k));

		return (bytes / Math.pow(k, i)).toFixed(decimals) + " " + sizes[i];
	});

	Vue.filter("pluralize", (value, ...args) => {
		return args.length > 1 ? args[value % 10 - 1] || args[args.length - 1] : args[0] + (value === 1 ? "" : "s");
	});
}
